// extracted by mini-css-extract-plugin
module.exports = {"profile-onboarding":"OnBoarding_profile-onboarding__1YYit","caption":"OnBoarding_caption__260Og"};